import Table from '@oncolens/oncolens-ui/lib/components/Common/Table';
import React from 'react';
import { FaPencilAlt } from 'react-icons/fa';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import { getUsers } from '../api/getUserList';
import { UserFilters } from '../routes/Users';
import { UserDto } from '../types';

interface UsersTableProps {
  filters: UserFilters;
}

export const UsersTable = ({ filters }: UsersTableProps) => {
  const columns = React.useMemo(
    () => [
      { accessor: 'actions', Header: '', Cell: ActionsColumn },
      { accessor: 'user', Header: 'User', Cell: UserColumn },
      { accessor: 'contact', Header: 'Contact', Cell: ContactColumn },
      { accessor: 'employment', Header: 'Employment', Cell: EmploymentColumn },
    ],
    [],
  );

  // TODO update with custom params for searching with user profile props
  const filtersDef = {
    ...(filters.search && { Filters: `email@=*${filters.search}` }),
  };

  return (
    <Table
      columns={columns}
      fetchData={getUsers}
      queryBaseKey="Users"
      additionalQueryParameters={filtersDef}
      options={{ textSize: 'sm' }}
    />
  );
};

export const MobileUsersTable = ({ filters }: UsersTableProps) => {
  const columns = React.useMemo(
    () => [
      { accessor: 'user', Header: 'User', Cell: UserColumn },
      { accessor: 'actions', Header: '', Cell: ActionsColumn },
    ],
    [],
  );

  // TODO update with custom params for searching with user profile props
  const filtersDef = {
    ...(filters.search && { Filters: `email@=*${filters.search}` }),
  };

  return (
    <Table
      columns={columns}
      fetchData={getUsers}
      queryBaseKey="Users"
      additionalQueryParameters={filtersDef}
      options={{ textSize: 'sm' }}
    />
  );
};

const ActionsColumn = ({ row: { original: data } }: UserTableColumnProps) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(`/users/${data.id}`)}
      className="text-gray-600 hover:text-gray-800">
      <FaPencilAlt className="w-4 h-4" />
    </button>
  );
};

interface UserTableColumnProps {
  row: {
    original: UserDto;
  };
}

const ContactColumn = ({ row: { original: data } }: UserTableColumnProps) => (
  <div className="px-6 py-4 whitespace-nowrap">
    <div className="flex justify-start text-sm text-gray-900" data-cy="request-row-template-name">
      {data?.email}
    </div>
    <div className="flex justify-start text-sm text-gray-500" data-cy="request-row-created-date">
      {data.userProfile?.phoneNumber ?? '-'}
    </div>
  </div>
);

const EmploymentColumn = ({ row: { original: data } }: UserTableColumnProps) => (
  <div className="px-6 py-4 whitespace-nowrap">
    <div className="flex justify-start text-sm text-gray-900" data-cy="request-row-template-name">
      {data?.userProfile?.employer}
    </div>
    <div className="flex justify-start text-sm text-gray-500" data-cy="request-row-created-date">
      {data.userProfile?.npi ?? '-'}
    </div>
  </div>
);

const UserColumn = ({ row: { original: data } }: UserTableColumnProps) => {
  let fullName = null;
  if (data.userProfile?.firstName && data.userProfile?.lastName)
    fullName = `${data.userProfile.firstName} ${data.userProfile.lastName}`;

  return (
    <div className="px-6 py-4 whitespace-nowrap">
      <div className="flex justify-start text-sm text-gray-900" data-cy="request-row-template-name">
        {fullName ?? '-'}
      </div>
      <div
        className="hidden text-sm text-gray-500 sm:justify-start sm:flex"
        data-cy="request-row-created-date">
        {data.userProfile?.specialty ?? '-'}
      </div>
    </div>
  );
};
